import React, { useState, useEffect, useCallback, memo } from 'react';
import './App.css';
import axios from 'axios';
import moment from 'moment';
import { BIBLE_VERSES } from "./bibleVerses";
import webSocketService, { WebSocketService } from './services/websocketService';
import cacheService from './services/cacheService';
import { HomeCover } from './components/Home/HomeCover';
import { ForgotPasswordModal } from './components/Auth/ForgotPasswordModal';
import { LoginModal } from './components/Auth/LoginModal';
import { ResetPasswordScreen } from './components/Auth/ResetPasswordScreen';
import { AlterarSenha } from './components/Auth/AlterarSenha';
import SelecionarIgreja from './components/Auth/SelecionarIgreja';
import { Dashboard } from './components/Dashboard/Dashboard';
import { Relatorios } from './components/Dashboard/Relatorios';
import { Turmas } from './components/CRUD/Turmas';
import { Usuarios } from './components/CRUD/Usuarios';
import Lixeira from './components/CRUD/Lixeira';
import AdminRevistas from './components/CRUD/AdminRevistas';
import RevistaPagamentos from './components/CRUD/RevistaPagamentos';
import AlunosFaltantes from './components/Features/AlunosFaltantes';
import Alunos from './components/Features/Alunos';
import Chamada from './components/Features/Chamada';
import HistoricoCompleto from './components/Features/HistoricoCompleto';
import Rankings from './components/Features/Rankings';
import Revistas from './components/Features/Revistas';
import FluxoCaixa from './components/Features/FluxoCaixa';
import ConfigChamadas from './components/Features/ConfigChamadas';
import ConfigDepartamentos from './components/Features/ConfigDepartamentos';
import RelatorioTurma from './components/Features/RelatorioTurma';
import GerenciarIgrejas from './components/Admin/GerenciarIgrejas';
import DashboardSuperAdmin from './components/Admin/DashboardSuperAdmin';
import ConfigEmailTemplates from './components/Admin/ConfigEmailTemplates';
import ContasReceber from './components/Admin/ContasReceber';
import { TrialRegisterModal } from './components/Auth/TrialRegisterModal';
import PlanosModal from './components/Planos/PlanosModal';
import PagamentoResultado from './components/Planos/PagamentoResultado';

// API URL - Usar URL relativa para funcionar com proxy interno
const API = '/api';

// Função para obter headers com autenticação
const getAuthHeaders = () => {
  const token = localStorage.getItem('ebd_token');
  const igrejaId = localStorage.getItem('ebd_igreja_id');
  
  // Verificar se o token está expirado
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const isExpired = payload.exp * 1000 < Date.now();
      
      if (isExpired) {
        // Token expirado - limpar localStorage e recarregar página
        localStorage.removeItem('ebd_token');
        localStorage.removeItem('ebd_user');
        localStorage.removeItem('ebd_igreja_id');
        localStorage.removeItem('ebd_igreja_nome');
        localStorage.removeItem('ebd_igreja_data');
        localStorage.removeItem('last_data_update');
        window.location.reload();
        return {
          'Content-Type': 'application/json'
        };
      }
    } catch (error) {
      // Token inválido - limpar localStorage
      localStorage.removeItem('ebd_token');
      localStorage.removeItem('ebd_user');
      localStorage.removeItem('ebd_igreja_id');
      localStorage.removeItem('ebd_igreja_nome');
      localStorage.removeItem('ebd_igreja_data');
      localStorage.removeItem('last_data_update');
      window.location.reload();
      return {
        'Content-Type': 'application/json'
      };
    }
  }
  
  const headers = {
    'Content-Type': 'application/json'
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Adicionar header X-Igreja-ID se houver igreja selecionada
  if (igrejaId && igrejaId !== 'all') {
    headers['X-Igreja-ID'] = igrejaId;
  }
  
  return headers;
};

// Função para marcar quando dados foram atualizados
const markDataAsUpdated = () => {
  localStorage.setItem('last_data_update', Date.now().toString());
};

// Versículos bíblicos - importados do arquivo bibleVerses.js

// Versículos agora são importados diretamente do arquivo bibleVerses.js

// Função para gerar link do WhatsApp com mensagem pré-pronta
  const gerarLinkWhatsApp = (telefone, nome, contexto = 'geral') => {
    if (!telefone) return null;
    
    // Limpar número - remover tudo que não é dígito
    const numeroLimpo = telefone.replace(/\D/g, '');
    
    // Mensagens personalizadas por contexto
    const mensagens = {
      geral: `Olá ${nome}! A paz do Senhor Jesus!\n\nEsperamos você na EBD deste domingo às 9h!\n\nIgreja Ministério Belém\nRua Managuá, 53 - Sumaré, SP`,
      faltante: `Olá ${nome}! A paz do Senhor Jesus!\n\nNotei que você não estava na aula de hoje, conto com você para a próxima aula, pois Deus tem falado poderosamente em nossos corações.\n\nEsperamos você neste domingo às 9h na EBD!\n\nIgreja Ministério Belém\nRua Managuá, 53 - Sumaré, SP`
    };
    
    const mensagem = mensagens[contexto] || mensagens.geral;
    const mensagemEncoded = encodeURIComponent(mensagem);
    
    // Adicionar código do país (55 - Brasil) se não tiver
    const numeroCompleto = numeroLimpo.startsWith('55') ? numeroLimpo : `55${numeroLimpo}`;
    
    return `https://wa.me/${numeroCompleto}?text=${mensagemEncoded}`;
  };



  // Função para obter versículo aleatório diário
const getDailyVerse = () => {
  const today = new Date().toDateString();
  const storedVerse = localStorage.getItem('dailyVerse');
  const storedDate = localStorage.getItem('dailyVerseDate');
  
  // Se já temos um versículo para hoje, retorna ele
  if (storedVerse && storedDate === today) {
    return JSON.parse(storedVerse);
  }
  
  // Gera seed baseado na data para versículo consistente por dia
  const seed = new Date().getDate() + new Date().getMonth() * 31 + new Date().getFullYear() * 365;
  const verseIndex = seed % BIBLE_VERSES.length;
  const dailyVerse = BIBLE_VERSES[verseIndex];
  
  // Armazena no localStorage
  localStorage.setItem('dailyVerse', JSON.stringify(dailyVerse));
  localStorage.setItem('dailyVerseDate', today);
  
  return dailyVerse;
};

function App() {
  // Funções utilitárias para cálculo de datas
  const isSunday = (dateString) => {
    const date = new Date(dateString + 'T00:00:00');
    return date.getDay() === 0;
  };

  // Função para obter o último domingo (para relatórios)
  const getLastSunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 = domingo, 1 = segunda, etc.
    
    if (dayOfWeek === 0) {
      // Se hoje é domingo, retorna hoje
      return today.toISOString().split('T')[0];
    } else {
      // Se não é domingo, retorna o domingo anterior
      const lastSunday = new Date(today);
      lastSunday.setDate(today.getDate() - dayOfWeek);
      return lastSunday.toISOString().split('T')[0];
    }
  };

  // Função para obter o próximo domingo (para chamadas)
  const getCurrentSunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 = domingo, 1 = segunda, etc.
    
    if (dayOfWeek === 0) {
      // Se hoje é domingo, retorna hoje
      return today.toISOString().split('T')[0];
    } else {
      // Se não é domingo, retorna o próximo domingo
      const nextSunday = new Date(today);
      nextSunday.setDate(today.getDate() + (7 - dayOfWeek));
      return nextSunday.toISOString().split('T')[0];
    }
  };

  const [currentView, setCurrentView] = useState('home');
  const [showApp, setShowApp] = useState(false);
  const [turmas, setTurmas] = useState([]);
  const [students, setStudents] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedTurma, setSelectedTurma] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => getLastSunday());
  const [loading, setLoading] = useState(false);
  
  // Estados de ranking
  const [rankingAlunos, setRankingAlunos] = useState([]);
  const [rankingProfessores, setRankingProfessores] = useState([]);
  const [rankingTurmas, setRankingTurmas] = useState([]);
  
  // Estados para backup e restore
  const [backupData, setBackupData] = useState(null);
  const [restoreLoading, setRestoreLoading] = useState(false);
  const [backupLoading, setBackupLoading] = useState(false);
  
  // Estados para logs de acesso - NOVO
  const [accessLogs, setAccessLogs] = useState([]);
  const [logStats, setLogStats] = useState({});
  const [logsLoading, setLogsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('alunos');

  // Estados para recuperação de senha
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [passwordResetMessage, setPasswordResetMessage] = useState('');
  const [resetToken, setResetToken] = useState('');
  
  // Estados para configurações do sistema - NOVO
  const [systemConfig, setSystemConfig] = useState({});
  const [configLoading, setConfigLoading] = useState(false);

  // Estado para configuração de departamentos - NOVO
  const [departamentosConfig, setDepartamentosConfig] = useState({
    departamentos: {},
    turmas_excluidas: []
  });

  // Estados de revistas
  const [revistas, setRevistas] = useState([]);
  const [revistaAtual, setRevistaAtual] = useState(null);

  // Estados do fluxo de caixa
  const [fluxoCaixa, setFluxoCaixa] = useState([]);
  const [saldoInicial, setSaldoInicial] = useState(0);
  const [relatorioFluxo, setRelatorioFluxo] = useState(null);

  // Estado do versículo diário
  const [dailyVerse, setDailyVerse] = useState({ text: '', reference: '' });
  
  // Estados de autenticação
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [showTrialRegister, setShowTrialRegister] = useState(false);
  const [showPlanos, setShowPlanos] = useState(false);
  const [planoInfo, setPlanoInfo] = useState(null); // { plano, alunos, turmas }
  const [pagamentoResultado, setPagamentoResultado] = useState(null); // 'sucesso'|'pendente'|'falha'|null

  // Estados Multi-Tenancy
  const [needsIgrejaSelection, setNeedsIgrejaSelection] = useState(false);
  const [igrejaAtual, setIgrejaAtual] = useState(null);

  // Função para desconectar WebSocket
  const disconnectWebSocket = useCallback(() => {
    webSocketService.disconnect();
  }, []);

  // Verificar se há sessão salva ao carregar
  // DESABILITADO: Sempre mostrar tela de login primeiro
  // O login determina qual igreja o usuário acessa
  useEffect(() => {
    // Limpar qualquer sessão antiga para forçar login manual sempre
    // Isso garante que sempre apareça a tela de login primeiro
    localStorage.removeItem('ebd_token');
    localStorage.removeItem('ebd_user');
    localStorage.removeItem('ebd_igreja_id');
    localStorage.removeItem('ebd_igreja_nome');
    localStorage.removeItem('ebd_igreja_data');
    
    // Garantir que sempre comece na tela inicial (não logado)
    setIsLoggedIn(false);
    setCurrentUser(null);
    setToken(null);
    setCurrentView('home');
    
    // Interceptor axios para capturar erros 401
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          // Token expirado ou inválido - fazer logout automático
          localStorage.removeItem('ebd_token');
          localStorage.removeItem('ebd_user');
          setToken(null);
          setCurrentUser(null);
          setIsLoggedIn(false);
          setCurrentView('home');
          setMessage('Sessão expirada. Faça login novamente.');
          disconnectWebSocket(); // Desconectar WebSocket no logout
        }
        return Promise.reject(error);
      }
    );
    
    // Função para renovar token automaticamente
    const renewToken = async () => {
      try {
        const currentToken = localStorage.getItem('ebd_token');
        if (!currentToken) return false;

        const response = await axios.post(`${API}/refresh-token`, {}, {
          headers: getAuthHeaders()
        });

        if (response.data.success) {
          const newToken = response.data.token;
          localStorage.setItem('ebd_token', newToken);
          setToken(newToken);
          return true;
        }
      } catch (error) {
        return false;
      }
      return false;
    };

    // Verificação periódica do token com renovação automática
    const checkTokenInterval = setInterval(async () => {
      const currentToken = localStorage.getItem('ebd_token');
      if (currentToken) {
        try {
          const payload = JSON.parse(atob(currentToken.split('.')[1]));
          const timeLeft = payload.exp * 1000 - Date.now();
          
          // Se restam menos de 60 minutos, tentar renovar
          if (timeLeft < 60 * 60 * 1000 && timeLeft > 0) {
            const renewed = await renewToken();
            if (renewed) {
              setMessage('Sessão renovada automaticamente.');
            } else {
              setMessage('Sua sessão expirará em breve. Salve seu trabalho.');
            }
          }
          
          // Se token expirou e não conseguiu renovar, fazer logout
          if (timeLeft <= 0) {
            const renewed = await renewToken();
            if (!renewed) {
              localStorage.removeItem('ebd_token');
              localStorage.removeItem('ebd_user');
              setToken(null);
              setCurrentUser(null);
              setIsLoggedIn(false);
              setCurrentView('home');
              setMessage('Sessão expirada. Faça login novamente.');
            }
          }
        } catch (error) {
          // Token inválido - tentar renovar ou fazer logout
          const renewed = await renewToken();
          if (!renewed) {
            localStorage.removeItem('ebd_token');
            localStorage.removeItem('ebd_user');
            setToken(null);
            setCurrentUser(null);
            setIsLoggedIn(false);
            setCurrentView('home');
          }
        }
      }
    }, 5 * 60 * 1000); // Verificar a cada 5 minutos
    
    // Limpar interceptor e interval quando componente for desmontado
    return () => {
      axios.interceptors.response.eject(interceptor);
      clearInterval(checkTokenInterval);
      disconnectWebSocket(); // Desconectar WebSocket ao desmontar componente
    };
  }, [disconnectWebSocket]);

  // Verificar retorno de pagamento Mercado Pago na URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pagamento = params.get('pagamento');
    if (pagamento && ['sucesso', 'pendente', 'falha'].includes(pagamento)) {
      setPagamentoResultado(pagamento);
      // Limpar params da URL sem recarregar
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  // Carregar info do plano quando igreja é selecionada
  const carregarPlanoInfo = useCallback(async (igrejaId) => {
    if (!igrejaId) return;
    try {
      const response = await axios.get(`${API}/igrejas/${igrejaId}/plano`, {
        headers: getAuthHeaders()
      });
      setPlanoInfo(response.data);
    } catch (error) {
      console.error('Erro ao carregar info do plano:', error);
    }
  }, []);

  // Atualizar data automaticamente baseado na view atual
  useEffect(() => {
    if (currentView === 'chamada') {
      // Para chamadas, usar o domingo atual/próximo
      setSelectedDate(getCurrentSunday());
    } else if (currentView === 'dashboard' || currentView === 'reports') {
      // Para relatórios, usar o último domingo
      setSelectedDate(getLastSunday());
    }
  }, [currentView]);

  // Carregar versículo diário
  useEffect(() => {
    try {
      const verse = getDailyVerse();
      setDailyVerse(verse);
    } catch (error) {
      // Versículo padrão em caso de erro
      setDailyVerse({
        text: "Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna.",
        reference: "João 3:16"
      });
    }
  }, []);

  // Recarregar dashboard automaticamente quando selectedDate mudar ou acessar relatórios
  useEffect(() => {
    if (isLoggedIn && (currentView === 'dashboard' || currentView === 'relatorios')) {
      loadDashboard();
    }
  }, [selectedDate, isLoggedIn, currentView]);

  // Função de login
  const handleLogin = async (email, senha) => {
    try {
      // LIMPAR CACHE E ESTADOS ANTES DO LOGIN (evitar vazamento de dados entre igrejas)
      cacheService.clearAllIgrejas();
      setTurmas([]);
      setStudents([]);
      setAttendanceData([]);
      setRevistas([]);
      setRankingAlunos([]);
      setRankingProfessores([]);
      setRankingTurmas([]);
      setRelatorioFluxo(null);
      setSaldoInicial(0);

      const response = await axios.post(`${API}/login`, { email, senha });
      const { user_id, nome, email: userEmail, tipo, turmas_permitidas, igrejas, token: userToken, trial_expiring, trial_days_left } = response.data;

      // Alertar sobre periodo expirando
      if (trial_expiring && trial_days_left !== null) {
        setTimeout(() => {
          alert(`Atenção: Seu período de avaliação expira em ${trial_days_left} dia(s). Acesse ebdad.com.br para assinar seu plano.`);
        }, 2000);
      }

      const userData = { user_id, nome, email: userEmail, tipo, turmas_permitidas, igrejas: igrejas || [] };

      setToken(userToken);
      setCurrentUser(userData);
      setShowLogin(false);

      // Salvar no localStorage
      localStorage.setItem('ebd_token', userToken);
      localStorage.setItem('ebd_user', JSON.stringify(userData));

      // Verificar se precisa selecionar igreja
      if (tipo === 'super_admin') {
        // Super admin não precisa selecionar igreja (acessa tudo)
        localStorage.setItem('ebd_igreja_id', 'all');
        localStorage.setItem('ebd_igreja_nome', 'Todas as Igrejas');
        setIgrejaAtual({ id: 'all', nome: 'Todas as Igrejas' });
        setIsLoggedIn(true);

        // Super admin NÃO precisa carregar dados operacionais (turmas, alunos, dashboard)
        // Ele vai direto para o painel SaaS de gerenciar igrejas

        // Configurar WebSocket (opcional para super_admin)
        setTimeout(() => setupWebSocket(), 1500);

        // Redirecionar direto para painel SaaS
        setCurrentView('gerenciar-igrejas');
      } else if (igrejas && igrejas.length > 1) {
        // Tem múltiplas igrejas - mostrar tela de seleção
        setNeedsIgrejaSelection(true);
      } else if (igrejas && igrejas.length === 1) {
        // Tem apenas 1 igreja - selecionar automaticamente
        const response = await axios.get(`${API}/igrejas/${igrejas[0]}`, { headers: getAuthHeaders() });
        const igreja = response.data;

        // Verificar se a igreja está ativa antes de permitir acesso
        if (!igreja.ativa) {
          throw new Error('A igreja está desativada. Entre em contato com o administrador.');
        }

        // LIMPAR CACHE E ESTADOS ANTES DE DEFINIR A IGREJA (evitar vazamento de dados)
        cacheService.clearAllIgrejas();
        setTurmas([]);
        setStudents([]);
        setAttendanceData([]);
        setRevistas([]);
        setRankingAlunos([]);
        setRankingProfessores([]);
        setRankingTurmas([]);
        setRelatorioFluxo(null);
        setSaldoInicial(0);

        localStorage.setItem('ebd_igreja_id', igreja.id);
        localStorage.setItem('ebd_igreja_nome', igreja.nome);
        localStorage.setItem('ebd_igreja_data', JSON.stringify(igreja));
        setIgrejaAtual(igreja);
        setIsLoggedIn(true);

        // Carregar dados da igreja
        await loadTurmas();
        await loadStudents();
        await loadDashboard();
        carregarPlanoInfo(igreja.id);

        // Configurar WebSocket
        setTimeout(() => setupWebSocket(), 1500);

        setCurrentView('dashboard');
      } else {
        // Sem igrejas
        throw new Error('Usuário sem acesso a nenhuma igreja');
      }

      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.detail || error.response?.data?.message || 'Erro de conectividade. Tente novamente.'
      };
    }
  };

  // Função de registro trial (com login automático)
  const handleTrialRegister = async (data) => {
    try {
      const response = await axios.post(`${API}/trial/register`, data);
      const result = response.data;

      // Login automático se o backend retornou token
      if (result.auto_login && result.token) {
        // Limpar cache antes do login
        cacheService.clearAllIgrejas();
        setTurmas([]);
        setStudents([]);
        setAttendanceData([]);
        setRevistas([]);
        setRankingAlunos([]);
        setRankingProfessores([]);
        setRankingTurmas([]);
        setRelatorioFluxo(null);
        setSaldoInicial(0);

        const userData = {
          user_id: result.user_id,
          nome: result.nome,
          email: data.email,
          tipo: result.tipo,
          turmas_permitidas: result.turmas_permitidas || [],
          igrejas: result.igrejas || []
        };

        setToken(result.token);
        setCurrentUser(userData);
        setShowLogin(false);
        setShowTrialRegister(false);

        localStorage.setItem('ebd_token', result.token);
        localStorage.setItem('ebd_user', JSON.stringify(userData));

        // Configurar igreja automaticamente
        const igreja = result.igreja;
        localStorage.setItem('ebd_igreja_id', igreja.id);
        localStorage.setItem('ebd_igreja_nome', igreja.nome);
        localStorage.setItem('ebd_igreja_data', JSON.stringify(igreja));
        setIgrejaAtual(igreja);
        setIsLoggedIn(true);

        // Carregar dados da igreja
        await loadTurmas();
        await loadStudents();
        await loadDashboard();
        carregarPlanoInfo(igreja.id);

        // Configurar WebSocket
        setTimeout(() => setupWebSocket(), 1500);

        setCurrentView('dashboard');

        return { success: true, auto_login: true };
      }

      return { success: true, message: result.message };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.detail || 'Erro ao criar conta. Tente novamente.'
      };
    }
  };

  // Função para selecionar igreja (após login com múltiplas igrejas)
  const handleIgrejaSelecionada = async (igreja) => {
    try {
      // Verificar se a igreja está ativa antes de permitir acesso
      if (!igreja.ativa) {
        alert('Esta igreja está desativada. Entre em contato com o administrador.');
        handleLogout();
        return;
      }

      // LIMPAR CACHE E ESTADOS ANTES DE TROCAR DE IGREJA (evitar vazamento de dados)
      const igrejaAnterior = localStorage.getItem('ebd_igreja_id');
      if (igrejaAnterior && igrejaAnterior !== igreja.id) {
        cacheService.clearByIgreja(igrejaAnterior);
      }
      cacheService.clearAll(); // Limpar todo cache para garantir isolamento
      setTurmas([]);
      setStudents([]);
      setAttendanceData([]);
      setRevistas([]);
      setRankingAlunos([]);
      setRankingProfessores([]);
      setRankingTurmas([]);
      setRelatorioFluxo(null);
      setSaldoInicial(0);

      setIgrejaAtual(igreja);
      setNeedsIgrejaSelection(false);
      setIsLoggedIn(true);

      // Carregar dados da nova igreja
      await loadTurmas();
      await loadStudents();
      await loadDashboard();
      carregarPlanoInfo(igreja.id);

      // Configurar WebSocket
      setTimeout(() => setupWebSocket(), 1500);

      setCurrentView('dashboard');
    } catch (error) {
      console.error('Erro ao selecionar igreja:', error);
    }
  };

  // Função de logout
  const handleLogout = async () => {
    try {
      if (token) {
        await axios.post(`${API}/logout?token=${token}`);
      }
    } catch (error) {
    }
    
    setToken(null);
    setCurrentUser(null);
    setIsLoggedIn(false);
    setCurrentView('home');
    
    
    // Desconectar WebSocket no logout
    disconnectWebSocket();
    
    // Limpar cache no logout
    clearCache();
    
    localStorage.removeItem('ebd_token');
    localStorage.removeItem('ebd_user');
    localStorage.removeItem('last_data_update');
    localStorage.removeItem('ebd_igreja_id');
    localStorage.removeItem('ebd_igreja_nome');
    localStorage.removeItem('ebd_igreja_data');
    setIgrejaAtual(null);
    setNeedsIgrejaSelection(false);
  };

  // Filtrar turmas baseado nas permissões do usuário
  const getFilteredTurmas = () => {
    if (!currentUser) return turmas;
    
    if (currentUser.tipo === 'admin' || currentUser.tipo === 'moderador') {
      return turmas; // Admin e Moderador veem todas
    } else {
      // Professor vê apenas suas turmas
      return turmas.filter(turma => currentUser.turmas_permitidas.includes(turma.id));
    }
  };

  // Carregar dados iniciais só será feito após login
  useEffect(() => {
    // Dados serão carregados apenas quando necessário e com autenticação
  }, []);

  const loadInitialData = async () => {
    try {
      await axios.post(`${API}/init-church-data`, {}, { headers: getAuthHeaders() });
      await loadTurmas();
      await loadStudents();
      await loadDashboard();
    } catch (error) {
    }
  };

  const loadTurmas = async (forceRefresh = false) => {
    // Só carregar se estiver autenticado
    const token = localStorage.getItem('ebd_token');
    if (!token) return;
    
    // Verificar se a igreja atual está ativa (se não for super_admin)
    if (igrejaAtual && igrejaAtual.id !== 'all' && !igrejaAtual.ativa && currentUser?.tipo !== 'super_admin') {
      alert('A igreja está desativada. Entre em contato com o administrador.');
      handleLogout();
      return;
    }
    
    try {
      const fetchFunction = async () => {
        const response = await axios.get(`${API}/turmas`, { headers: getAuthHeaders() });
        return response.data;
      };

      let data;
      if (forceRefresh) {
        // Invalidar cache e buscar dados frescos
        cacheService.invalidateType('turmas');
        data = await fetchFunction();
        cacheService.set('turmas', data);
      } else {
        // Usar cache inteligente
        data = await cacheService.getOrFetch('turmas', fetchFunction);
      }

      setTurmas(data);
      markDataAsUpdated(); // Marcar dados como atualizados
    } catch (error) {
    }
  };

  const loadStudents = async (forceRefresh = false) => {
    // Só carregar se estiver autenticado
    const token = localStorage.getItem('ebd_token');
    if (!token) return;
    
    try {
      const fetchFunction = async () => {
        const response = await axios.get(`${API}/students`, { headers: getAuthHeaders() });
        return response.data;
      };

      let data;
      if (forceRefresh) {
        // Invalidar cache e buscar dados frescos
        cacheService.invalidateType('students');
        data = await fetchFunction();
        cacheService.set('students', data);
      } else {
        // Usar cache inteligente
        data = await cacheService.getOrFetch('students', fetchFunction);
      }

      setStudents(data);
      markDataAsUpdated(); // Marcar dados como atualizados
    } catch (error) {
    }
  };

  const loadRevistas = async (forceRefresh = false) => {
    if (!isLoggedIn || !token) return;
    
    try {
      const fetchFunction = async () => {
        const response = await axios.get(`${API}/revistas`, { headers: getAuthHeaders() });
        return response.data;
      };

      let data;
      if (forceRefresh) {
        // Invalidar cache e buscar dados frescos
        cacheService.invalidateType('revistas');
        data = await fetchFunction();
        cacheService.set('revistas', data);
      } else {
        // Usar cache inteligente
        data = await cacheService.getOrFetch('revistas', fetchFunction);
      }

      setRevistas(data);
      markDataAsUpdated(); // Marcar dados como atualizados
    } catch (error) {
    }
  };

  // Função para carregar todos os dados principais
  const loadAllData = useCallback(async (forceRefresh = false) => {
    if (!isLoggedIn || !token) return;
    
    try {
      await Promise.all([
        loadTurmas(forceRefresh),
        loadStudents(forceRefresh),
        loadRevistas(forceRefresh)
      ]);
    } catch (error) {
    }
  }, [isLoggedIn, token]);


  // Configurar WebSocket
  const setupWebSocket = useCallback(() => {
    if (!token) return;

    
    // Conectar
    webSocketService.connect(token);

    // Solicitar permissão para notificações
    WebSocketService.requestNotificationPermission();

    // Listeners para eventos WebSocket

    webSocketService.on('authenticated', (data) => {
    });

    webSocketService.on('auth_error', (data) => {
    });

    // Listeners para updates de dados específicos
let lastStudentReload = 0;    webSocketService.on("data_update:student_created", (data) => {      const now = Date.now();      if (now - lastStudentReload > 1000) {        cacheService.invalidateType("students");        loadStudents(true);        lastStudentReload = now;        showRealtimeNotification(data.message, "success");      }    });

let lastStudentDeleteReload = 0;    webSocketService.on("data_update:student_deleted", (data) => {      const now = Date.now();      if (now - lastStudentDeleteReload > 1000) {        cacheService.invalidateType("students");        loadStudents(true);        lastStudentDeleteReload = now;        showRealtimeNotification(data.message, "info");      }    });

    webSocketService.on('data_update:attendance_updated', (data) => {
      cacheService.invalidateType('attendance'); // Invalidar cache
      // Recarregar dados de presença se necessário
      if (typeof loadAttendanceData === 'function') {
        loadAttendanceData(true);
      }
      showRealtimeNotification(data.message, 'success');
    });

  }, [token]);


  // Desconectar WebSocket
  // Limpar cache
  const clearCache = useCallback(() => {
    cacheService.clearAll();
  }, []);

  // Funções para recuperação de senha
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/forgot-password`, {
        email: forgotPasswordEmail
      });
      setPasswordResetMessage('Se o email existir no sistema, você receberá instruções para redefinir a senha');
      setForgotPasswordEmail('');
    } catch (error) {
      setPasswordResetMessage('Erro ao processar solicitação. Tente novamente.');
    }
  };

  // Verificar se há token de reset ou ação na URL ao carregar a página
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const acao = urlParams.get('acao');

    if (token && token.length > 0) {
      setResetToken(token);
      setCurrentView('reset-password');
    }
    // Abrir modal de planos quando vem do app (?acao=planos)
    if (acao === 'planos') {
      setShowPlanos(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  const loadRevistaByTurma = async (turmaId) => {
    try {
      const response = await axios.get(`${API}/revistas/turma/${turmaId}`, { headers: getAuthHeaders() });
      setRevistaAtual(response.data);
    } catch (error) {
      setRevistaAtual(null);
    }
  };

  // Ordem específica das turmas para relatórios (nomes exatos do sistema)
  const ordemTurmasRelatorio = [
    'Professores e Oficiais',
    'Genesis',
    'Primarios',
    'Juniores',
    'Pré-Adolescentes',
    'Adolescentes',
    'Jovens',
    'Soldados de Cristo',
    'Dorcas (irmãs)',
    'Ebenezer (Obreiros)',
    'Discipulados'
  ];

  const loadDashboard = async () => {
    // Só carregar se estiver autenticado
    const token = localStorage.getItem('ebd_token');
    if (!token) return;
    
    try {
      const response = await axios.get(`${API}/reports/dashboard?data=${selectedDate}`, { headers: getAuthHeaders() });

      // Ordenar dados conforme ordem personalizada das turmas
      const dadosOrdenados = response.data.sort((a, b) => {
        const indexA = ordemTurmasRelatorio.indexOf(a.turma_nome);
        const indexB = ordemTurmasRelatorio.indexOf(b.turma_nome);

        // Se não encontrar na lista, coloca no final
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
      });

      setAttendanceData(dadosOrdenados);

      // Carregar configurações do sistema
      loadSystemConfig();
      loadDepartamentosConfig();
    } catch (error) {
    }
  };

  const loadRankings = async () => {
    try {
      const [alunosResponse, professoresResponse, turmasResponse] = await Promise.all([
        axios.get(`${API}/ranking/alunos`, { headers: getAuthHeaders() }),
        axios.get(`${API}/ranking/professores-oficiais`, { headers: getAuthHeaders() }),
        axios.get(`${API}/ranking/turmas`, { headers: getAuthHeaders() })
      ]);
      
      setRankingAlunos(alunosResponse.data);
      setRankingProfessores(professoresResponse.data);
      setRankingTurmas(turmasResponse.data);
    } catch (error) {
    }
  };

  // Funções de Logs de Acesso - NOVO
  const loadAccessLogs = async () => {
    try {
      setLogsLoading(true);
      const response = await axios.get(`${API}/access-logs?limit=50`, { headers: getAuthHeaders() });
      setAccessLogs(response.data || []);
    } catch (error) {
      setAccessLogs([]);
    } finally {
      setLogsLoading(false);
    }
  };

  const loadAccessStats = async () => {
    try {
      const response = await axios.get(`${API}/access-logs/stats`, { headers: getAuthHeaders() });
      setLogStats(response.data || {});
    } catch (error) {
      setLogStats({});
    }
  };

  // Funções para Configurações do Sistema - NOVO
  const loadSystemConfig = async () => {
    try {
      setConfigLoading(true);
      const response = await axios.get(`${API}/system-config`, { headers: getAuthHeaders() });
      setSystemConfig(response.data || {});
    } catch (error) {
      setSystemConfig({});
    } finally {
      setConfigLoading(false);
    }
  };

  const updateSystemConfig = async (bloqueioAtivo, horario = "13:00") => {
    try {
      setConfigLoading(true);
      await axios.put(`${API}/system-config?bloqueio_ativo=${bloqueioAtivo}&user_id=${currentUser.user_id || currentUser.id}&horario=${horario}`, {}, { headers: getAuthHeaders() });
      await loadSystemConfig(); // Recarregar configurações
      alert('Configurações atualizadas com sucesso!');
    } catch (error) {
      alert(`Erro ao atualizar configurações: ${error.response?.data?.detail || error.message}`);
    } finally {
      setConfigLoading(false);
    }
  };

  // Funções para Configuração de Departamentos - NOVO
  const loadDepartamentosConfig = async () => {
    try {
      const response = await axios.get(`${API}/departamentos-config`, { headers: getAuthHeaders() });
      setDepartamentosConfig(response.data || { departamentos: {}, turmas_excluidas: [] });
    } catch (error) {
      setDepartamentosConfig({ departamentos: {}, turmas_excluidas: [] });
    }
  };

  // Funções de Backup e Restore
  const generateBackup = async () => {
    try {
      setBackupLoading(true);
      const response = await axios.get(`${API}/backup/generate`, { headers: getAuthHeaders() });

      if (response.data.success) {
        const filename = response.data.filename;

        if (response.data.is_encrypted && response.data.backup_encrypted) {
          // Backup criptografado (.ebd) - download como binário
          const byteCharacters = atob(response.data.backup_encrypted);
          const byteArray = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i);
          }
          const dataBlob = new Blob([byteArray], {type: 'application/octet-stream'});
          const url = URL.createObjectURL(dataBlob);

          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        } else {
          // Backup JSON limpo (super_admin)
          const backup = response.data.backup;
          const dataStr = JSON.stringify(backup, null, 2);
          const dataBlob = new Blob([dataStr], {type: 'application/json'});
          const url = URL.createObjectURL(dataBlob);

          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }

        alert(`✅ Backup gerado com sucesso!\n\nArquivo: ${filename}\nTamanho: ${response.data.size_mb?.toFixed(2).replace('.', ',')} MB\n\nResumo:\n👥 Usuários: ${response.data.summary.users}\n🏫 Turmas: ${response.data.summary.turmas}\n📚 Alunos: ${response.data.summary.students}\n📊 Chamadas: ${response.data.summary.attendance}\n📖 Revistas: ${response.data.summary.revistas}`);

      } else {
        alert('❌ Erro ao gerar backup: ' + response.data.message);
      }
    } catch (error) {
      alert('❌ Erro ao gerar backup: ' + (error.response?.data?.detail || error.message));
    } finally {
      setBackupLoading(false);
    }
  };

  const handleRestoreFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Arquivo .ebd = backup criptografado
      if (file.name.endsWith('.ebd')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const arrayBuffer = e.target.result;
          const byteArray = new Uint8Array(arrayBuffer);
          let binary = '';
          for (let i = 0; i < byteArray.length; i++) {
            binary += String.fromCharCode(byteArray[i]);
          }
          const base64 = btoa(binary);

          const confirmMessage = `🔒 RESTORE DE BACKUP CRIPTOGRAFADO\n\n📄 Arquivo: ${file.name}\n📦 Tamanho: ${(file.size / (1024 * 1024)).toFixed(2)} MB\n\n🔴 ATENÇÃO: Esta operação irá SUBSTITUIR todos os dados existentes!\n\n❓ Deseja continuar com o restore?`;

          if (window.confirm(confirmMessage)) {
            executeRestore({ backup_encrypted: base64 });
          }
        };
        reader.readAsArrayBuffer(file);
      } else {
        // Arquivo JSON (formato legado / super_admin)
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            let backupData = JSON.parse(e.target.result);

            if (backupData.backup && typeof backupData.backup === 'object') {
              backupData = backupData.backup;
            }

            if (!backupData.data && !backupData.metadata) {
              alert('Arquivo inválido: formato de backup não reconhecido');
              return;
            }

            const metadata = backupData.metadata || {};
            const data = backupData.data || backupData;

            let confirmMessage = `📤 RESTORE DE BACKUP\n\n`;
            if (metadata.backup_date) {
              confirmMessage += `📅 Data do backup: ${new Date(metadata.backup_date).toLocaleString()}\n`;
            }
            if (metadata.total_records) {
              confirmMessage += `📊 Total de registros: ${metadata.total_records}\n`;
            }

            confirmMessage += `\n🔴 ATENÇÃO: Esta operação irá SUBSTITUIR todos os dados existentes!\n\n`;
            confirmMessage += `📋 Dados que serão restaurados:\n`;

            Object.keys(data).forEach(collection => {
              const count = data[collection]?.length || 0;
              const collectionNames = {
                users: '👤 Usuários',
                turmas: '🏫 Turmas',
                students: '📚 Alunos',
                attendance: '📊 Chamadas',
                revistas: '📖 Revistas'
              };
              confirmMessage += `   ${collectionNames[collection] || collection}: ${count} registros\n`;
            });

            confirmMessage += `\n❓ Deseja continuar com o restore?`;

            if (window.confirm(confirmMessage)) {
              executeRestore(backupData);
            }

          } catch (error) {
            alert('❌ Erro ao ler arquivo: formato inválido. Use arquivos .ebd ou .json');
          }
        };
        reader.readAsText(file);
      }
    }

    // Limpar input para permitir selecionar o mesmo arquivo novamente
    event.target.value = '';
  };

  const executeRestore = async (backupData) => {
    try {
      setRestoreLoading(true);
      
      const response = await axios.post(`${API}/backup/restore`, backupData, { headers: getAuthHeaders() });
      
      if (response.data.success) {
        const summary = response.data.restore_summary;
        let successMessage = `✅ Backup restaurado com sucesso!\n\n📊 Registros restaurados:\n`;
        
        Object.keys(summary).forEach(collection => {
          const count = summary[collection];
          const collectionNames = {
            users: '👤 Usuários',
            turmas: '🏫 Turmas',
            students: '📚 Alunos', 
            attendance: '📊 Chamadas',
            revistas: '📖 Revistas'
          };
          successMessage += `   ${collectionNames[collection] || collection}: ${count} registros\n`;
        });
        
        successMessage += `\n🔄 Total: ${response.data.total_restored} registros\n\n🔄 Recarregando sistema...`;
        
        alert(successMessage);
        
        // Recarregar dados
        await loadDashboard();
        await loadTurmas();
        await loadStudents();
        
      } else {
        alert('❌ Erro ao restaurar backup: ' + response.data.message);
      }
    } catch (error) {
      alert('❌ Erro ao restaurar backup: ' + (error.response?.data?.detail || error.message));
    } finally {
      setRestoreLoading(false);
    }
  };

  const loadAttendanceForTurma = async (turmaId, date) => {
    try {
      const response = await axios.get(`${API}/attendance?turma_id=${turmaId}&data=${date}`, { headers: getAuthHeaders() });
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const saveAttendance = async (turmaId, date, attendanceList) => {
    try {
      setLoading(true);
      
      // Prepare data for API
      const attendanceData = attendanceList.map(att => ({
        aluno_id: att.aluno_id,
        status: att.status,
        oferta: parseFloat((att.oferta || '0').toString().replace(',', '.')) || 0,
        biblias_entregues: parseInt(att.biblias_entregues) || 0,
        revistas_entregues: parseInt(att.revistas_entregues) || 0
      }));

      const response = await axios.post(`${API}/attendance/bulk/${turmaId}?data=${date}&user_tipo=${currentUser.tipo}&user_id=${currentUser.user_id || currentUser.id}`, attendanceData, { headers: getAuthHeaders() });
      
      await loadDashboard();
      alert('Chamada salva com sucesso!');
    } catch (error) {
      if (error.response?.data?.detail) {
        alert(`Erro: ${error.response.data.detail}`);
      } else {
        alert('Erro ao salvar chamada');
      }
    } finally {
      setLoading(false);
    }
  };

  // Componente Dashboard - Movido para components/Dashboard/Dashboard.jsx

  // Componente Alunos Faltantes (implementação completa)


  // Verificar se há token de reset na URL ao carregar a página
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token && token.length > 0) {
      setResetToken(token);
      setCurrentView('reset-password');
    }
  }, []);

  const calcularClassesVencedoras = () => {
    if (!attendanceData || attendanceData.length === 0) return {};

    // Função para normalizar nomes (case-insensitive, trim, sem acentos)
    const normalizar = (nome) => {
      if (!nome) return '';
      return nome.toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // remove acentos
        .replace(/[-]/g, ' '); // substitui hífens por espaços
    };

    // Verificar se há configuração de departamentos
    if (!departamentosConfig.departamentos || Object.keys(departamentosConfig.departamentos).length === 0) {
      // Sem configuração = não calcular vencedores
      return {};
    }

    // Usar configuração dinâmica de departamentos
    const departamentos = {};
    Object.keys(departamentosConfig.departamentos).forEach(dept => {
      departamentos[dept] = departamentosConfig.departamentos[dept].map(turma => normalizar(turma));
    });

    // Turmas a excluir (usar configuração)
    const excluir = departamentosConfig.turmas_excluidas && departamentosConfig.turmas_excluidas.length > 0
      ? departamentosConfig.turmas_excluidas.map(turma => normalizar(turma))
      : [];

    // Preparar dados com porcentagem de frequência
    const turmasComFrequencia = attendanceData.map(turma => ({
      ...turma,
      porcentagem_frequencia_decimal: turma.matriculados > 0 ? (turma.presentes / turma.matriculados) : 0
    }));

    const vencedores = {};

    // Para cada departamento
    Object.keys(departamentos).forEach(dept => {
      const turmasValidas = departamentos[dept];
      
      // Filtrar turmas válidas para este departamento
      const turmasDept = turmasComFrequencia.filter(turma => {
        const nomeNormalizado = normalizar(turma.turma_nome);
        
        // Excluir turmas da lista de exclusão
        if (excluir.includes(nomeNormalizado)) return false;
        
        // Incluir apenas se estiver na whitelist do departamento
        return turmasValidas.includes(nomeNormalizado);
      });

      if (turmasDept.length > 0) {
        // CLASSE VENCEDORA EM FREQUÊNCIA (maior percentual)
        const maxFrequencia = Math.max(...turmasDept.map(t => t.porcentagem_frequencia_decimal));
        const vencedorFrequencia = turmasDept.find(t => t.porcentagem_frequencia_decimal === maxFrequencia);

        // CLASSE VENCEDORA EM OFERTA (maior valor)
        const maxOferta = Math.max(...turmasDept.map(t => t.total_ofertas));
        const vencedorOferta = turmasDept.find(t => t.total_ofertas === maxOferta);

        vencedores[dept] = {
          frequencia: {
            turma_nome: vencedorFrequencia.turma_nome,
            porcentagem: Math.round(maxFrequencia * 100 * 100) / 100
          },
          oferta: {
            turma_nome: vencedorOferta.turma_nome,
            valor: Math.round(maxOferta * 100) / 100
          }
        };
      }
    });

    return vencedores;
  };



  // Componente Relatorios - Movido para components/Dashboard/Relatorios.jsx

  // Componente Histórico Completo - Movido para components/Features/HistoricoCompleto.jsx


  // Componente Chamada - Movido para components/Features/Chamada.jsx

  // Componente Alunos - Movido para components/Features/Alunos.jsx

  // Componente Turmas - Movido para components/CRUD/Turmas.jsx

  // Componente Usuários - Movido para components/CRUD/Usuarios.jsx


  // Componente Rankings - Movido para components/Features/Rankings.jsx

  // Componente Logs de Acesso - NOVO
  const LogsAcesso = () => {
    const formatarData = (timestamp) => {
      if (!timestamp) return 'N/A';
      return new Date(timestamp).toLocaleString('pt-BR');
    };

    const formatarDuracao = (loginTime, logoutTime) => {
      if (!loginTime || !logoutTime) return 'N/A';
      const inicio = new Date(loginTime);
      const fim = new Date(logoutTime);
      const duracao = Math.round((fim - inicio) / 1000 / 60); // em minutos
      return duracao < 60 ? `${duracao}min` : `${Math.floor(duracao/60)}h${duracao%60}min`;
    };

    return (
      <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <button
              onClick={() => setCurrentView('dashboard')}
              className="mb-4 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              ← Voltar ao Dashboard
            </button>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Logs de Acesso</h1>
            <p className="text-gray-600">Histórico de acessos ao sistema</p>
          </div>

          {/* Estatísticas Rápidas */}
          {logStats && Object.keys(logStats).length > 0 && (
            <div className="bg-white rounded-lg shadow p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Estatísticas</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-blue-50 rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-blue-600">{logStats.total_logins || 0}</div>
                  <div className="text-sm text-blue-500">Total de Logins</div>
                </div>
                <div className="bg-green-50 rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-green-600">{logStats.usuarios_ativos || 0}</div>
                  <div className="text-sm text-green-500">Usuários Ativos</div>
                </div>
                <div className="bg-purple-50 rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-purple-600">{logStats.sessoes_ativas || 0}</div>
                  <div className="text-sm text-purple-500">Sessões Ativas</div>
                </div>
              </div>
            </div>
          )}

          {/* Tabela de Logs */}
          <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold text-gray-800">Histórico de Acesso</h2>
                <button
                  onClick={() => {
                    loadAccessLogs();
                    loadAccessStats();
                  }}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  🔄 Atualizar
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              {logsLoading ? (
                <div className="p-8 text-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
                  <p className="mt-2 text-gray-600">Carregando logs...</p>
                </div>
              ) : (
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Usuário
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Login
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Logout
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Duração
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        IP
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {accessLogs.length > 0 ? (
                      accessLogs.map((log, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <div>
                                <div className="text-sm font-medium text-gray-900">{log.user_name}</div>
                                <div className="text-sm text-gray-500">ID: {log.user_id}</div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {formatarData(log.timestamp)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {log.logout_time ? formatarData(log.logout_time) : (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Ativo
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {formatarDuracao(log.timestamp, log.logout_time)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {log.ip_address || 'N/A'}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                          Nenhum log de acesso encontrado
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {accessLogs.length > 0 && (
              <div className="px-6 py-3 bg-gray-50 border-t border-gray-200">
                <p className="text-sm text-gray-700">
                  Exibindo {accessLogs.length} registros mais recentes
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Componente para Controle de Pagamento de Revistas

  // Renderização condicional
  const renderCurrentView = () => {
    // Se não está logado, mostrar apenas home (exceto para reset de senha)
    if (!isLoggedIn && currentView !== 'home' && currentView !== 'reset-password') {
      setCurrentView('home');
      return <HomeCover
        isLoggedIn={isLoggedIn}
        currentUser={currentUser}
        onNavigate={setCurrentView}
        onLogout={handleLogout}
        onShowLogin={() => setShowLogin(true)}
        onShowTrialRegister={() => setShowTrialRegister(true)}
      />;
    }

    // Se está na tela de seleção de igreja, não renderizar outras views
    if (needsIgrejaSelection && !isLoggedIn) {
      return null; // Será renderizado fora do switch
    }

    switch(currentView) {
      case 'home':
        return <HomeCover
          isLoggedIn={isLoggedIn}
          currentUser={currentUser}
          onNavigate={setCurrentView}
          onLogout={handleLogout}
          onShowLogin={() => setShowLogin(true)}
          onShowTrialRegister={() => setShowTrialRegister(true)}
        />;
      case 'dashboard':
        // Super admin não deve ver dashboard operacional - redirecionar para painel SaaS
        if (isLoggedIn && currentUser?.tipo === 'super_admin') {
          setCurrentView('gerenciar-igrejas');
          return null;
        }
        return isLoggedIn ? <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
          planoInfo={planoInfo}
          onShowPlanos={() => setShowPlanos(true)}
        /> : <HomeCover
          isLoggedIn={isLoggedIn}
          currentUser={currentUser}
          onNavigate={setCurrentView}
          onLogout={handleLogout}
          onShowLogin={() => setShowLogin(true)}
          onShowTrialRegister={() => setShowTrialRegister(true)}
        />;
      case 'chamada':
        return isLoggedIn ? <Chamada
          API={API}
          getAuthHeaders={getAuthHeaders}
          students={students}
          loadAttendanceForTurma={loadAttendanceForTurma}
          selectedTurma={selectedTurma}
          setSelectedTurma={setSelectedTurma}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          turmas={turmas}
          getFilteredTurmas={getFilteredTurmas}
          isSunday={isSunday}
          loadDashboard={loadDashboard}
          currentUser={currentUser}
          setLoading={setLoading}
          loading={loading}
          setCurrentView={setCurrentView}
        /> : <HomeCover
          isLoggedIn={isLoggedIn}
          currentUser={currentUser}
          onNavigate={setCurrentView}
          onLogout={handleLogout}
          onShowLogin={() => setShowLogin(true)}
          onShowTrialRegister={() => setShowTrialRegister(true)}
        />;
      case 'relatorios':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin' || currentUser?.tipo === 'visitante') ? <Relatorios
          calcularClassesVencedoras={calcularClassesVencedoras}
          attendanceData={attendanceData}
          ordemTurmasRelatorio={ordemTurmasRelatorio}
          setCurrentView={setCurrentView}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          loadDashboard={loadDashboard}
          isSunday={isSunday}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'historico':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin' || currentUser?.tipo === 'visitante') ? <HistoricoCompleto
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'ranking':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin' || currentUser?.tipo === 'visitante') ? <Rankings
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
          rankingAlunos={rankingAlunos}
          setRankingAlunos={setRankingAlunos}
          rankingProfessores={rankingProfessores}
          setRankingProfessores={setRankingProfessores}
          rankingTurmas={rankingTurmas}
          setRankingTurmas={setRankingTurmas}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'alunos':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin' || currentUser?.tipo === 'visitante') ? <Alunos
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
          students={students}
          turmas={turmas}
          loadStudents={loadStudents}
          currentUser={currentUser}
          getFilteredTurmas={getFilteredTurmas}
          gerarLinkWhatsApp={gerarLinkWhatsApp}
          planoInfo={planoInfo}
          onShowPlanos={() => setShowPlanos(true)}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'turmas':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin' || currentUser?.tipo === 'visitante') ? <Turmas
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          turmas={turmas}
          students={students}
          loadTurmas={loadTurmas}
          planoInfo={planoInfo}
          onShowPlanos={() => setShowPlanos(true)}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'usuarios':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'superadmin') ? <Usuarios
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          turmas={turmas}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'alterar-senha':
        return isLoggedIn ? <AlterarSenha
          currentUser={currentUser}
          onBack={() => setCurrentView('dashboard')}
        /> : <HomeCover
          isLoggedIn={isLoggedIn}
          currentUser={currentUser}
          onNavigate={setCurrentView}
          onLogout={handleLogout}
          onShowLogin={() => setShowLogin(true)}
          onShowTrialRegister={() => setShowTrialRegister(true)}
        />;
      case 'reset-password':
        return <ResetPasswordScreen token={resetToken} onCancel={() => setCurrentView('home')} />;
      case 'revistas':
        return isLoggedIn ? <Revistas
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          revistas={revistas}
          loadRevistas={loadRevistas}
          turmas={turmas}
        /> : <HomeCover
          isLoggedIn={isLoggedIn}
          currentUser={currentUser}
          onNavigate={setCurrentView}
          onLogout={handleLogout}
          onShowLogin={() => setShowLogin(true)}
          onShowTrialRegister={() => setShowTrialRegister(true)}
        />;
      case 'admin-revistas':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador') ? <AdminRevistas
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
          loadRevistas={loadRevistas}
          turmas={turmas}
          revistas={revistas}
          currentUser={currentUser}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'revista-pagamentos':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'superadmin') ? <RevistaPagamentos
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'lixeira':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador') ? <Lixeira
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
          loadTurmas={loadTurmas}
          loadStudents={loadStudents}
          loadRevistas={loadRevistas}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'fluxo-caixa':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'superadmin') ? <FluxoCaixa setCurrentView={setCurrentView} API={API} getAuthHeaders={getAuthHeaders} /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'faltantes':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin') ? <AlunosFaltantes
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
          students={students}
          turmas={turmas}
          gerarLinkWhatsApp={gerarLinkWhatsApp}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'relatorio-turma':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin' || currentUser?.tipo === 'visitante') ? <RelatorioTurma
          API={API}
          getAuthHeaders={getAuthHeaders}
          setCurrentView={setCurrentView}
          turmas={turmas}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'config-chamadas':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'superadmin') ? <ConfigChamadas
          setCurrentView={setCurrentView}
          systemConfig={systemConfig}
          configLoading={configLoading}
          updateSystemConfig={updateSystemConfig}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'config-departamentos':
        return isLoggedIn && (currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'superadmin') ? <ConfigDepartamentos
          setCurrentView={setCurrentView}
          currentUser={currentUser}
        /> : <Dashboard
          dailyVerse={dailyVerse}
          setCurrentView={setCurrentView}
          currentUser={currentUser}
          selectedDate={selectedDate}
          loadDashboard={loadDashboard}
          attendanceData={attendanceData}
          setActiveTab={setActiveTab}
          generateBackup={generateBackup}
          backupLoading={backupLoading}
          restoreLoading={restoreLoading}
          handleRestoreFile={handleRestoreFile}
          turmas={turmas}
          students={students}
          handleLogout={handleLogout}
          getFilteredTurmas={getFilteredTurmas}
          igrejaAtual={igrejaAtual}
          setNeedsIgrejaSelection={setNeedsIgrejaSelection}
        />;
      case 'dashboard-admin':
        return isLoggedIn && currentUser?.tipo === 'super_admin' ? (
          <DashboardSuperAdmin setCurrentView={setCurrentView} />
        ) : null;
      case 'contas-receber':
        return isLoggedIn && currentUser?.tipo === 'super_admin' ? (
          <ContasReceber setCurrentView={setCurrentView} />
        ) : null;
      case 'config-email-templates':
        return isLoggedIn && currentUser?.tipo === 'super_admin' ? (
          <ConfigEmailTemplates setCurrentView={setCurrentView} />
        ) : null;
      case 'gerenciar-igrejas':
        return isLoggedIn && currentUser?.tipo === 'super_admin' ? (
          <GerenciarIgrejas
            setCurrentView={setCurrentView}
            currentUser={currentUser}
            onLogout={handleLogout}
          />
        ) : (
          <Dashboard
            dailyVerse={dailyVerse}
            setCurrentView={setCurrentView}
            currentUser={currentUser}
            selectedDate={selectedDate}
            loadDashboard={loadDashboard}
            attendanceData={attendanceData}
            setActiveTab={setActiveTab}
            generateBackup={generateBackup}
            backupLoading={backupLoading}
            restoreLoading={restoreLoading}
            handleRestoreFile={handleRestoreFile}
            turmas={turmas}
            students={students}
            handleLogout={handleLogout}
            getFilteredTurmas={getFilteredTurmas}
          />
        );
      default:
        return <HomeCover
          isLoggedIn={isLoggedIn}
          currentUser={currentUser}
          onNavigate={setCurrentView}
          onLogout={handleLogout}
          onShowLogin={() => setShowLogin(true)}
          onShowTrialRegister={() => setShowTrialRegister(true)}
        />;
    }
  };

  // Tela de seleção de igreja (Multi-Tenancy)
  if (needsIgrejaSelection && !isLoggedIn) {
    return (
      <SelecionarIgreja
        user={currentUser}
        onIgrejaSelecionada={handleIgrejaSelecionada}
        onLogout={handleLogout}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {renderCurrentView()}
      <LoginModal
        show={showLogin}
        onClose={() => setShowLogin(false)}
        onLogin={handleLogin}
        onForgotPassword={() => {
          setShowLogin(false);
          setShowForgotPassword(true);
        }}
        onTrialRegister={() => {
          setShowLogin(false);
          setShowTrialRegister(true);
        }}
      />
      <ForgotPasswordModal
        show={showForgotPassword}
        email={forgotPasswordEmail}
        message={passwordResetMessage}
        onClose={() => {
          setShowForgotPassword(false);
          setPasswordResetMessage('');
          setForgotPasswordEmail('');
        }}
        onSubmit={handleForgotPassword}
        onEmailChange={(e) => setForgotPasswordEmail(e.target.value)}
      />
      <TrialRegisterModal
        show={showTrialRegister}
        onClose={() => setShowTrialRegister(false)}
        onRegister={handleTrialRegister}
        onBackToLogin={() => {
          setShowTrialRegister(false);
          setShowLogin(true);
        }}
      />
      <PlanosModal
        isOpen={showPlanos}
        onClose={() => setShowPlanos(false)}
        igrejaId={igrejaAtual?.id}
        planoAtual={planoInfo?.plano}
        valorMensal={planoInfo?.valor_mensal}
        planoAtivoAte={planoInfo?.plano_ativo_ate}
        diaVencimento={planoInfo?.dia_vencimento}
        emAtraso={planoInfo?.em_atraso}
        diasAtraso={planoInfo?.dias_atraso}
        onPlanoAtualizado={(dados) => {
          setPlanoInfo(dados);
          setShowPlanos(false);
          alert('Pagamento confirmado! Seu plano foi ativado com sucesso.');
        }}
      />
      {pagamentoResultado && (
        <PagamentoResultado
          tipo={pagamentoResultado}
          onVoltar={() => {
            setPagamentoResultado(null);
            setCurrentView('dashboard');
          }}
        />
      )}
    </div>
  );
}


export default App;